// Date parsing and validation utilities
export interface DateValue {
  isRange: boolean;
  fromDate: string;
  toDate: string;
}

export const DATE_SEPARATOR = ':';

export const parseDateValue = (value: string): DateValue => {
  if (!value) {
    return { isRange: false, fromDate: '', toDate: '' };
  }

  const isRange = value.includes(DATE_SEPARATOR);
  const [fromDate, toDate] = isRange ? value.split(DATE_SEPARATOR) : [value, ''];

  return { isRange, fromDate: fromDate || '', toDate: toDate || '' };
};

export const validateDateRange = (fromDate: string, toDate: string): boolean => {
  if (!fromDate || !toDate) return false;
  return toDate < fromDate;
};

export const formatDateRange = (fromDate: string, toDate: string): string => {
  if (!fromDate && !toDate) return '';
  if (!toDate && fromDate) return `${fromDate}${DATE_SEPARATOR}`;
  if (!fromDate && toDate) return `${DATE_SEPARATOR}${toDate}`;
  return `${fromDate}${DATE_SEPARATOR}${toDate}`;
};
